import HeroSection from '../Components/HeroSection'
import Slider from '../Components/Slider/Slider'
import Contact from '../Components/Contact/Contact'
import Footer from '../Components/Footer/Footer'
import InfoSection from '../Components/Infosection/Index'
import { homeObjOne } from '../Components/Infosection/Data'
import ScrollToTop from '../Components/ScrollToTop'
import Sidebar from '../Components/SideBar/index'
import { useState } from 'react'

const Home = () => {
  const [isOpen, setIsOpen] = useState(false)
    
     const toggle = () => {
      setIsOpen(!isOpen)
     }
  return (
    <>
        <ScrollToTop />
        <Sidebar isOpen={isOpen} toggle={toggle} />
        <HeroSection />
        <Slider />
        <InfoSection {...homeObjOne} />
        <Contact />
        <Footer />
    </>
  )
}

export default Home